module.exports = (RESTService) ->
  'ngInject'
  RESTService
    .withConfig((r) -> r.setDefaultHttpFields(cache: true))
    .service('admin/categories')
